import React, { useState, useRef } from "react";
import QurealStandardEditor from "../qureal_editor/QurealStandardEditor";
import styles from "./styles/BlogEditor.module.css";

const BlogEditor = ({
    initialContent,
    onChange,
    onEditorInit,
    darkMode = false,
}) => {
    const [content, setContent] = useState(
        initialContent || '<h1 class="is-empty"></h1><p class="is-empty"></p>'
    );
    const wrapper_Style = { padding: "0.5rem 2rem 2rem 2rem" };
    const contentRef = useRef(content);

    // Store content in ref without causing re-renders
    const handleChange = (htmlContent) => {
        setContent(htmlContent);
        contentRef.current = htmlContent;

        // Initialize editor instance with methods
        if (onEditorInit && !editorInitialized.current) {
            onEditorInit({
                getHTML: () => contentRef.current,
                getCurrentContent: () => {
                    // Parse HTML to extract title and body when needed
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(
                        contentRef.current,
                        "text/html"
                    );

                    const titleElement = doc.querySelector("h1");
                    const title = titleElement ? titleElement.textContent : "";

                    const bodyDoc = parser.parseFromString(
                        contentRef.current,
                        "text/html"
                    );
                    const titleElem = bodyDoc.querySelector("h1");
                    if (titleElem) titleElem.remove();
                    const body = bodyDoc.body.innerHTML;

                    return {
                        title,
                        body,
                        fullContent: contentRef.current,
                    };
                },
            });
            editorInitialized.current = true;
        }
    };

    const editorInitialized = useRef(false);

    return (
        <div>
            <QurealStandardEditor
                value={content}
                onChange={handleChange}
                darkMode={darkMode}
                placeholder={{
                    title: "Title",
                    paragraph: "Tell your story...",
                }}
                wrapper_style={wrapper_Style}
            />
        </div>
    );
};

export default BlogEditor;
